import { useEbolMatchingContext } from '../EbolMatchingContext'
import { useSelectedBol } from './useSelectedBol'

type EbolDrawerTypes = 'closed' | 'viewingAll' | 'loading' | 'error' | 'match' | 'unmatch' | 'justMatched'
export const useDrawerType = (): EbolDrawerTypes => {
  const state = useEbolMatchingContext()
  const { data, status, fetchStatus } = useSelectedBol()
  if (!state.isOpen) return 'closed'

  if (state.hasJustMatched) return 'justMatched'

  if (!state.selectedBolId) return 'viewingAll'

  if (status === 'pending' || fetchStatus === 'fetching') return 'loading'

  if (status === 'error' || !data) return 'error'

  return data.ebol_status === 'matched' ? 'unmatch' : 'match'
}
